import API from '@/api'
import Utils from '@/plugins/request/utils'

export default {
  data() {
    return {
      pending: false
    }
  },
  methods: {
    __reloadPage() {
      window.location.href = window.location.origin + window.location.pathname + window.location.search
    },
    parseParams(str = '') {
      let ret = {}
      if (str.includes('?')) {
        str = str.replace('?', '')
      }
      if (str && str.includes('=')) {
        let arr = str.split('&')
        arr.map(d => {
          ret[d.split('=')[0]] = d.split('=')[1]
        })
      }
      return ret
    },
    async openWechatPay(e,params={}) {
      e.stopPropagation()
      if (this.pending) {
        return
      }

      this.pending = true

      this.$vux.loading.show({
        text: '加载中'
      })

      let res = {}
      const formMap = ('formMap' in this) ? this.formMap : {}
      const search = window.location.search
      const configs = this.parseParams(search)
      const way = configs['way'] ? configs['way'] : 0
      const sid = this.$storage.getItem('sid') || '0'
      try {
        res = await this.$http({
          method: 'POST',
          url: API.common.signUp,
          params: {
            token: this.$storage.getItem('token'),
            openid: this.$storage.getItem('openid'),
            channel: this.$storage.getItem('prev_channel') || this.$storage.getItem('channel'),
            activity_id: this.$route.params.eventId,
            ...formMap,
            ...params,
            way,
            sid,
            prev_uid: this.$storage.getItem('puid'),
          }
        })
      } catch (err) {
        this.$vux.loading.hide()
        this.pending = false
        return this.$vux.toast.show({
          text: err.message,
          type: 'cancel'
        })
      }

      if (!res.order_no) {
        this.pending = false
        this.$vux.loading.hide()
        this.$vux.toast.show({
          text: '已提交'
        })
        return setTimeout(this.__reloadPage, 1500)
      }

      try {
        const preOrderInfo = res.param
        let act_title = window.localStorage.getItem('activity_title')
        let money = JSON.parse(window.localStorage.getItem('activity_config'))['signUp']['price']
        let prepay_id = preOrderInfo.package.split('=')[1];
        let pay_url = 'https://wxp.shenhudong.com/module_pay/index_minipay.php?appid=' + preOrderInfo.appId + '&timestamp=' + preOrderInfo.timestamp + '&nonceStr=' + preOrderInfo.nonceStr + '&prepay_id=' + prepay_id + '&signType=' + preOrderInfo.signType + '&paySign=' + preOrderInfo.paySign
        window.location = pay_url+'&price='+money+'&product_title='+act_title+'&activity_id='+this.$route.params.eventId+'&openid='+this.$storage.getItem('openid')
        return
        await this.$wx.payment({
          appId: preOrderInfo.appId,
          timestamp: preOrderInfo.timestamp,
          nonceStr: preOrderInfo.nonceStr,
          pkg: preOrderInfo.package,
          signType: preOrderInfo.signType,
          paySign: preOrderInfo.paySign
        })
      } catch (err) {
        this.pending = false
        this.$vux.loading.hide()
        return this.$vux.confirm.show({
          title: '支付失败',
          content: JSON.stringify(err),
          showCancelButton: false
        })
      }

      this.$vux.loading.hide()
      // this.$vux.toast.show({
      //   type: 'text',
      //   content: '支付成功'
      // })

      return setTimeout(this.__reloadPage, 1500)
    }
  }
}